export default __webpack_public_path__ + "static/media/boite_a_idees.1ece150f.svg";